import * as TYPE from "../types";
const initialState = {
  data: [],
  error: null,
  count: 0,
  totalPages: 0,
};
export const customersReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPE.CUSTOMERS_DATA_FOUND:
      return {
        ...state,
        data: action.payload.data,
        count: action.payload.count,
        totalPages: action.payload.totalPages,
      };
    case TYPE.CUSTOMERS_DATA_ERROR:
      return {
        ...state,
        error: action.payload || true,
        msg: "OOPS! Something went wrong!",
        data: [],
        count: 0,
        totalPages: 0,
      };
    default:
      return state;
  }
};
